// // import styled, { keyframes } from 'styled-components';
// // import { lighten, darken } from 'polished';
// // import { ReactSVG } from 'react-svg';

// // const slideInFromLeft = keyframes`
// //  from {
// //    transform: translateX(-100%);
// //  }

// //  to {
// //    transform: translateX(0);
// //  }
// //  `;

// // /**
// //  * O recuo lateral de 20px foi retirado: a área de trabalho do desenho
// //  * ganha essa largura de volta e o cartão da página já tem recuo próprio.
// //  * O min-height:0 é o que permite o Wrapper esticar até o fim da altura
// //  * disponível quando a página define uma altura de viewport.
// //  */
// // export const Container = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   padding: 0;
// //   width: 100%;
// //   height: 100%;
// //   min-height: 0;
// // `;

// // export const Wrapper = styled.div`
// //   display: flex;
// //   justify-content: center;
// //   position: relative;
// //   border: 1px dashed #ccc;
// //   padding: 2px;
// //   width: 100%;

// //   /** ocupa toda a altura restante abaixo da barra de ferramentas */
// //   flex: 1 1 auto;
// //   min-height: 0;
// //   overflow: hidden;
// // `;

// // // export const ToolBar = styled.div`
// // //   padding: 5px 0;
// // //   display: flex;
// // //   align-items: center;

// // //   > button {
// // //     display: flex;
// // //     align-items: center;
// // //     justify-content: center;
// // //     background: none;
// // //     border: 1px solid #ccc;
// // //     border-radius: 5px;
// // //     margin-right: 5px;
// // //     width: 30px;
// // //     height: 30px;
// // //   }
// // // `;

// // export const ToolBar = styled.div`
// //   display: flex;
// //   align-items: center;
// //   flex-wrap: wrap;
// //   gap: 6px;
// //   padding: 8px;
// //   margin-bottom: 6px;
// //   background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
// //   /* border: 1px solid rgba(216, 224, 235, 0.9); */
// //   border-radius: 12px;
// //   box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);

// //   > button {
// //     display: inline-flex;
// //     align-items: center;
// //     justify-content: center;
// //     width: 30px;
// //     height: 30px;
// //     border: 1px solid rgba(216, 224, 235, 0.9);
// //     border-radius: 10px;
// //     background: #fff;
// //     color: #5b6b82;
// //     cursor: pointer;
// //     transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease,
// //       box-shadow 0.18s ease, transform 0.18s ease;

// //     > svg {
// //       display: block;
// //     }

// //     &:hover:not(:disabled) {
// //       color: #ff6d3c;
// //       background: rgba(255, 109, 60, 0.1);
// //       border-color: rgba(255, 109, 60, 0.45);
// //       box-shadow: 0 6px 14px rgba(255, 109, 60, 0.18);
// //       transform: translateY(-1px);
// //     }

// //     &:active:not(:disabled) {
// //       transform: translateY(0);
// //       box-shadow: 0 3px 8px rgba(255, 109, 60, 0.22);
// //     }

// //     &:focus-visible {
// //       outline: none;
// //       border-color: rgba(255, 109, 60, 0.6);
// //       box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.18);
// //     }

// //     &:disabled {
// //       color: #c2cad6;
// //       background: #f1f5f9;
// //       border-color: rgba(216, 224, 235, 0.7);
// //       cursor: not-allowed;
// //       box-shadow: none;
// //       transform: none;
// //     }

// //     /* botão primário (Salvar / submit) em destaque */
// //     &[type='submit'] {
// //       color: #fff;
// //       background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
// //       border-color: transparent;
// //       box-shadow: 0 6px 14px rgba(34, 197, 94, 0.28);

// //       &:hover:not(:disabled) {
// //         color: #fff;
// //         background: linear-gradient(135deg, #1fb555 0%, #28c763 100%);
// //         border-color: transparent;
// //         box-shadow: 0 10px 20px rgba(34, 197, 94, 0.4);
// //         transform: translateY(-1px);
// //       }
// //     }
// //   }
// // `;

// // // export const ToolBar = styled.div`
// // //   display: flex;
// // //   align-items: center;
// // //   gap: 16px;
// // //   padding: 3px 4px;
// // //   flex-wrap: wrap;
// // //   background: #fff;
// // //   border-bottom: 1px solid #e6e6e6;
// // // `;

// // export const ToolGroup = styled.div`
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 16px;
// //   padding: 4px 8px;
// //   border-radius: 8px;
// //   background: #f8f8f8;
// // `;

// // export const Divider = styled.div`
// //   width: 1px;
// //   height: 18px;
// //   background: #e0e0e0;
// //   margin: 0 4px;
// // `;

// // export const Btn = styled.button`
// //   display: inline-flex;
// //   align-items: center;
// //   justify-content: center;
// //   width: 24px;
// //   height: 24px;
// //   border-radius: 6px;
// //   border: 0;
// //   background: transparent;
// //   &:hover {
// //     background: #eee;
// //   }
// //   &[aria-pressed='true'] {
// //     background: #ddd;
// //     box-shadow: inset 0 0 0 1px #bbb;
// //   }
// // `;

// // export const Segmented = styled.div`
// //   display: inline-flex;
// //   border: 1px solid #ddd;
// //   border-radius: 8px;
// //   overflow: hidden;
// // `;

// // export const SegBtn = styled(Btn)`
// //   width: 34px;
// //   height: 28px;
// //   border-radius: 0;
// //   &:not(:last-child) {
// //     border-right: 1px solid #ddd;
// //   }
// // `;

// // export const DPad = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(3, 14px);
// //   grid-template-rows: repeat(3, 14px);
// //   gap: 2px;
// //   align-items: center;
// //   justify-items: center;
// //   & > button {
// //     width: 14px;
// //     height: 14px;
// //     border: 0;
// //     border-radius: 6px;
// //     background: transparent;
// //     &:hover {
// //       background: #eee;
// //     }
// //   }
// //   & > button:nth-child(1) {
// //     grid-column: 1;
// //     grid-row: 2;
// //   } /* esquerda */
// //   & > button:nth-child(2) {
// //     grid-column: 2;
// //     grid-row: 1;
// //   } /* cima */
// //   & > button:nth-child(3) {
// //     grid-column: 2;
// //     grid-row: 3;
// //   } /* baixo */
// //   & > button:nth-child(4) {
// //     grid-column: 3;
// //     grid-row: 2;
// //   } /* direita */
// // `;

// // export const SVG = styled(ReactSVG)`
// //   /**
// //    * O react-svg repassa as props extras para o wrapper (um <div>), e é
// //    * nele que ficam o tabIndex="0" e os handlers de teclado. Sem nenhuma
// //    * indicação visual o usuário não tinha como saber se o desenho estava
// //    * com o foco — e portanto por que Del / Alt+Z / Alt+S não respondiam.
// //    */
// //   &:focus {
// //     outline: none;
// //     box-shadow: inset 0 0 0 2px rgba(255, 109, 60, 0.35);
// //   }

// //   svg {
// //     tspan,
// //     text {
// //       pointer-events: none;
// //       -webkit-user-select: none;
// //       -khtml-user-select: none;
// //       -moz-user-select: -moz-none;
// //       -o-user-select: none;
// //       user-select: none;
// //     }

// //     a:hover {
// //       > circle,
// //       rect {
// //         &.inject:hover {
// //           fill: ${lighten(0.1, '#538061')};
// //         }
// //       }

// //       > text {
// //         stroke: #f5f5f5;
// //         fill: #f5f5f5;
// //       }
// //     }

// //     a.highlight {
// //       > circle,
// //       rect {
// //         &.inject {
// //           fill: ${lighten(0.1, '#538061')};
// //         }
// //       }

// //       > text {
// //         stroke: #f5f5f5;
// //         fill: #f5f5f5;
// //       }
// //     }

// //     &.selected {
// //       stroke: red;
// //       fill: red;
// //     }

// //     circle,
// //     rect {
// //       &.inject {
// //         stroke: green;
// //       }

// //       &.warning {
// //         stroke: red;
// //       }
// //     }

// //     #linkGroup {
// //       a {
// //         &.selected {
// //           circle,
// //           rect {
// //             stroke: blue;
// //           }
// //         }

// //         &.focused {
// //           circle,
// //           rect {
// //             stroke-width: 1.8px;
// //           }
// //         }
// //       }
// //     }

// //     #ocrGroup {
// //       a {
// //         rect {
// //           fill: rgba(255, 255, 255, 0.1);
// //           stroke: none;
// //         }

// //         :hover {
// //           rect.success {
// //             stroke: green;
// //           }

// //           rect.warning {
// //             stroke: red;
// //           }
// //         }

// //         &.selected {
// //           > rect.success {
// //             stroke: green;
// //           }

// //           > rect.warning {
// //             stroke: red;
// //           }
// //         }

// //         > text.success {
// //           fill: green;
// //           stroke: green;
// //         }

// //         > text.warning {
// //           fill: red;
// //           stroke: red;
// //         }
// //       }
// //     }
// //   }
// // `;

// // export const EditorWrapper = styled.div`
// //   position: relative;
// //   border: 1px solid #ccc;

// //   /**
// //    * Preenche o Wrapper para o react-zoom-pan-pinch receber uma altura
// //    * real. Com altura automática o centerOnInit não tinha referência e a
// //    * área útil ficava limitada ao tamanho intrínseco do SVG.
// //    */
// //   display: flex;
// //   flex: 1 1 auto;
// //   min-width: 0;
// //   min-height: 0;
// //   overflow: hidden;
// // `;

// // export const ControlWrapper = styled.div`
// //   position: absolute;
// //   left: 0;
// //   display: flex;
// //   z-index: 97;
// // `;

// // export const Control = styled.div`
// //   display: flex;
// //   position: relative;
// //   order: ${(props) => {
// //     switch (props.control) {
// //       case 'zoom':
// //         return '1;';
// //       case 'size':
// //         return '2;';
// //       default:
// //         return 0;
// //     }
// //   }};
// //   padding: 2px 5px;
// //   overflow: hidden;
// // `;

// // Control.BtnClose = styled.button`
// //   position: absolute;
// //   top: -2px;
// //   left: -2px;
// //   background: none;
// //   border: 0;

// //   color: #de3b3b;
// //   z-index: 2;
// // `;

// // /* animacao para o load do componente */
// // Control.Animated = styled.div`
// //   display: flex;
// //   flex-flow: row nowrap;

// //   height: 2.5rem;

// //   border: none;
// //   background: none;

// //   animation: ${slideInFromLeft} 0.5s ease-out 0s 1;
// // `;

// // /** Zoom */
// // Control.ZoomBtnAct = styled.button`
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   margin-left: 1px;
// //   border: 1px solid #cbd0d8;
// //   border-radius: 5px;
// //   height: 40px;
// //   width: 40px;
// //   background: #fff;
// //   color: #cbd0d8;

// //   :hover {
// //     background: ${darken(0.1, '#f2f5fc')};
// //     color: ${darken(0.1, '#1789dd')};
// //   }
// // `;

// // /** Size */
// // Control.SizeInput = styled.div`
// //   display: flex;

// //   div {
// //     padding: 1px;
// //   }
// // `;

// // /**
// //  * =====================================================================
// //  * LEGENDA DE ATALHOS
// //  * ---------------------------------------------------------------------
// //  * Painel flutuante sobre o desenho, FECHADO por padrão. É aberto pelo
// //  * botão "?" da barra de ferramentas ou pelas teclas "?" / F1, e fechado
// //  * pelo mesmo caminho ou por Esc.
// //  *
// //  * Fica em position:absolute dentro do EditorWrapper de propósito: assim
// //  * não empurra o layout nem reduz a área de trabalho quando está oculto.
// //  * =====================================================================
// //  */
// // export const Atalhos = styled.aside`
// //   position: absolute;
// //   top: 8px;
// //   right: 8px;
// //   z-index: 99;

// //   display: flex;
// //   flex-direction: column;

// //   width: 330px;
// //   max-width: calc(100% - 16px);
// //   max-height: calc(100% - 16px);

// //   background: #fff;
// //   border: 1px solid rgba(216, 224, 235, 0.9);
// //   border-radius: 12px;
// //   box-shadow: 0 12px 30px rgba(23, 38, 59, 0.18);

// //   overflow: hidden;
// // `;

// // Atalhos.Header = styled.div`
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   gap: 8px;

// //   padding: 8px 10px;
// //   border-bottom: 1px solid #eef2f7;
// //   background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);

// //   > strong {
// //     font-size: 12px;
// //     color: #2c405a;
// //     text-transform: uppercase;
// //     letter-spacing: 0.04em;
// //   }
// // `;

// // Atalhos.BtnClose = styled.button`
// //   display: inline-flex;
// //   align-items: center;
// //   justify-content: center;

// //   width: 22px;
// //   height: 22px;

// //   border: 0;
// //   border-radius: 6px;
// //   background: none;
// //   color: #94a3b8;
// //   cursor: pointer;

// //   &:hover {
// //     color: #de3b3b;
// //     background: rgba(222, 59, 59, 0.08);
// //   }
// // `;

// // /** corpo rolável: em tela baixa a legenda rola dentro dela mesma */
// // Atalhos.Body = styled.div`
// //   flex: 1 1 auto;
// //   min-height: 0;
// //   overflow-y: auto;
// //   padding: 4px 10px 10px;
// // `;

// // Atalhos.Grupo = styled.div`
// //   padding-top: 8px;

// //   > span {
// //     display: block;
// //     margin-bottom: 4px;
// //     font-size: 10px;
// //     font-weight: 700;
// //     color: #94a3b8;
// //     text-transform: uppercase;
// //     letter-spacing: 0.06em;
// //   }
// // `;

// // Atalhos.Linha = styled.div`
// //   display: flex;
// //   align-items: baseline;
// //   justify-content: space-between;
// //   gap: 10px;

// //   padding: 3px 0;
// //   border-bottom: 1px dashed #f1f5f9;

// //   &:last-child {
// //     border-bottom: 0;
// //   }

// //   > p {
// //     flex: 1 1 auto;
// //     font-size: 11.5px;
// //     line-height: 1.35;
// //     color: #475569;
// //   }

// //   > div {
// //     flex: 0 0 auto;
// //     display: flex;
// //     align-items: center;
// //     gap: 3px;
// //     white-space: nowrap;
// //   }
// // `;

// // Atalhos.Tecla = styled.kbd`
// //   display: inline-block;
// //   min-width: 18px;
// //   padding: 1px 5px;

// //   font-family: inherit;
// //   font-size: 10.5px;
// //   font-weight: 700;
// //   color: #2c405a;
// //   text-align: center;

// //   background: #f8fafc;
// //   border: 1px solid #d8e0eb;
// //   border-bottom-width: 2px;
// //   border-radius: 5px;
// // `;

// import styled, { keyframes } from 'styled-components';
// import { lighten, darken } from 'polished';
// import { ReactSVG } from 'react-svg';

// const slideInFromLeft = keyframes`
//  from {
//    transform: translateX(-100%);
//  }

//  to {
//    transform: translateX(0);
//  }
//  `;

// /**
//  * O recuo lateral de 20px foi retirado: a área de trabalho do desenho
//  * ganha essa largura de volta e o cartão da página já tem recuo próprio.
//  * O min-height:0 é o que permite o Wrapper esticar até o fim da altura
//  * disponível quando a página define uma altura de viewport.
//  */
// export const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 0;
//   width: 100%;
//   height: 100%;
//   min-height: 0;
// `;

// export const Wrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   position: relative;
//   border: 1px dashed #ccc;
//   padding: 2px;
//   width: 100%;

//   /** ocupa toda a altura restante abaixo da barra de ferramentas */
//   flex: 1 1 auto;
//   min-height: 0;
//   overflow: hidden;
// `;

// // export const ToolBar = styled.div`
// //   padding: 5px 0;
// //   display: flex;
// //   align-items: center;

// //   > button {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     background: none;
// //     border: 1px solid #ccc;
// //     border-radius: 5px;
// //     margin-right: 5px;
// //     width: 30px;
// //     height: 30px;
// //   }
// // `;

// export const ToolBar = styled.div`
//   display: flex;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 6px;
//   padding: 8px;
//   margin-bottom: 6px;
//   background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
//   /* border: 1px solid rgba(216, 224, 235, 0.9); */
//   border-radius: 12px;
//   box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);

//   > button {
//     display: inline-flex;
//     align-items: center;
//     justify-content: center;
//     width: 30px;
//     height: 30px;
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     border-radius: 10px;
//     background: #fff;
//     color: #5b6b82;
//     cursor: pointer;
//     transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease,
//       box-shadow 0.18s ease, transform 0.18s ease;

//     > svg {
//       display: block;
//     }

//     &:hover:not(:disabled) {
//       color: #ff6d3c;
//       background: rgba(255, 109, 60, 0.1);
//       border-color: rgba(255, 109, 60, 0.45);
//       box-shadow: 0 6px 14px rgba(255, 109, 60, 0.18);
//       transform: translateY(-1px);
//     }

//     &:active:not(:disabled) {
//       transform: translateY(0);
//       box-shadow: 0 3px 8px rgba(255, 109, 60, 0.22);
//     }

//     &:focus-visible {
//       outline: none;
//       border-color: rgba(255, 109, 60, 0.6);
//       box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.18);
//     }

//     &:disabled {
//       color: #c2cad6;
//       background: #f1f5f9;
//       border-color: rgba(216, 224, 235, 0.7);
//       cursor: not-allowed;
//       box-shadow: none;
//       transform: none;
//     }

//     /* botão primário (Salvar / submit) em destaque */
//     &[type='submit'] {
//       color: #fff;
//       background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
//       border-color: transparent;
//       box-shadow: 0 6px 14px rgba(34, 197, 94, 0.28);

//       &:hover:not(:disabled) {
//         color: #fff;
//         background: linear-gradient(135deg, #1fb555 0%, #28c763 100%);
//         border-color: transparent;
//         box-shadow: 0 10px 20px rgba(34, 197, 94, 0.4);
//         transform: translateY(-1px);
//       }
//     }
//   }
// `;

// // export const ToolBar = styled.div`
// //   display: flex;
// //   align-items: center;
// //   gap: 16px;
// //   padding: 3px 4px;
// //   flex-wrap: wrap;
// //   background: #fff;
// //   border-bottom: 1px solid #e6e6e6;
// // `;

// export const ToolGroup = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 16px;
//   padding: 4px 8px;
//   border-radius: 8px;
//   background: #f8f8f8;
// `;

// export const Divider = styled.div`
//   width: 1px;
//   height: 18px;
//   background: #e0e0e0;
//   margin: 0 4px;
// `;

// export const Btn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   width: 24px;
//   height: 24px;
//   border-radius: 6px;
//   border: 0;
//   background: transparent;
//   &:hover {
//     background: #eee;
//   }
//   &[aria-pressed='true'] {
//     background: #ddd;
//     box-shadow: inset 0 0 0 1px #bbb;
//   }
// `;

// export const Segmented = styled.div`
//   display: inline-flex;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   overflow: hidden;
// `;

// export const SegBtn = styled(Btn)`
//   width: 34px;
//   height: 28px;
//   border-radius: 0;
//   &:not(:last-child) {
//     border-right: 1px solid #ddd;
//   }
// `;

// export const DPad = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 14px);
//   grid-template-rows: repeat(3, 14px);
//   gap: 2px;
//   align-items: center;
//   justify-items: center;
//   & > button {
//     width: 14px;
//     height: 14px;
//     border: 0;
//     border-radius: 6px;
//     background: transparent;
//     &:hover {
//       background: #eee;
//     }
//   }
//   & > button:nth-child(1) {
//     grid-column: 1;
//     grid-row: 2;
//   } /* esquerda */
//   & > button:nth-child(2) {
//     grid-column: 2;
//     grid-row: 1;
//   } /* cima */
//   & > button:nth-child(3) {
//     grid-column: 2;
//     grid-row: 3;
//   } /* baixo */
//   & > button:nth-child(4) {
//     grid-column: 3;
//     grid-row: 2;
//   } /* direita */
// `;

// export const SVG = styled(ReactSVG)`
//   /**
//    * =====================================================================
//    * O DESENHO OCUPA TODA A ÁREA DE TRABALHO
//    * ---------------------------------------------------------------------
//    * O react-svg monta wrapper (este componente) > div interna > svg. Os
//    * três precisam preencher a área, senão o <svg> fica no tamanho dos
//    * atributos width/height (614x874) e sobra espaço vazio em volta.
//    *
//    * Com width/height em 100% e o viewBox definido em handleResize, o
//    * preserveAspectRatio padrão (xMidYMid meet) escala o desenho para
//    * caber e o centraliza sozinho — sem conta de posicionamento.
//    * =====================================================================
//    */
//   width: 100%;
//   height: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   /** div interna criada pelo react-svg */
//   > div {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     width: 100%;
//     height: 100%;
//     min-width: 0;
//     min-height: 0;
//   }

//   /**
//    * O react-svg repassa as props extras para o wrapper (um <div>), e é
//    * nele que ficam o tabIndex="0" e os handlers de teclado. Sem nenhuma
//    * indicação visual o usuário não tinha como saber se o desenho estava
//    * com o foco — e portanto por que Del / Alt+Z / Alt+S não respondiam.
//    */
//   &:focus {
//     outline: none;
//     box-shadow: inset 0 0 0 2px rgba(255, 109, 60, 0.35);
//   }

//   svg {
//     /** fluido: o tamanho vem da área, não dos atributos do arquivo */
//     width: 100%;
//     height: 100%;
//     max-width: 100%;
//     max-height: 100%;
//     display: block;

//     tspan,
//     text {
//       pointer-events: none;
//       -webkit-user-select: none;
//       -khtml-user-select: none;
//       -moz-user-select: -moz-none;
//       -o-user-select: none;
//       user-select: none;
//     }

//     a:hover {
//       > circle,
//       rect {
//         &.inject:hover {
//           fill: ${lighten(0.1, '#538061')};
//         }
//       }

//       > text {
//         stroke: #f5f5f5;
//         fill: #f5f5f5;
//       }
//     }

//     a.highlight {
//       > circle,
//       rect {
//         &.inject {
//           fill: ${lighten(0.1, '#538061')};
//         }
//       }

//       > text {
//         stroke: #f5f5f5;
//         fill: #f5f5f5;
//       }
//     }

//     &.selected {
//       stroke: red;
//       fill: red;
//     }

//     circle,
//     rect {
//       &.inject {
//         stroke: green;
//       }

//       &.warning {
//         stroke: red;
//       }
//     }

//     #linkGroup {
//       a {
//         &.selected {
//           circle,
//           rect {
//             stroke: blue;
//           }
//         }

//         &.focused {
//           circle,
//           rect {
//             stroke-width: 1.8px;
//           }
//         }
//       }
//     }

//     #ocrGroup {
//       a {
//         rect {
//           fill: rgba(255, 255, 255, 0.1);
//           stroke: none;
//         }

//         :hover {
//           rect.success {
//             stroke: green;
//           }

//           rect.warning {
//             stroke: red;
//           }
//         }

//         &.selected {
//           > rect.success {
//             stroke: green;
//           }

//           > rect.warning {
//             stroke: red;
//           }
//         }

//         > text.success {
//           fill: green;
//           stroke: green;
//         }

//         > text.warning {
//           fill: red;
//           stroke: red;
//         }
//       }
//     }
//   }
// `;

// export const EditorWrapper = styled.div`
//   position: relative;
//   border: 1px solid #ccc;

//   /**
//    * Preenche o Wrapper para o react-zoom-pan-pinch receber uma altura
//    * real. Com altura automática o centerOnInit não tinha referência e a
//    * área útil ficava limitada ao tamanho intrínseco do SVG.
//    */
//   display: flex;
//   flex: 1 1 auto;
//   min-width: 0;
//   min-height: 0;
//   overflow: hidden;
// `;

// export const ControlWrapper = styled.div`
//   position: absolute;
//   left: 0;
//   display: flex;
//   z-index: 97;
// `;

// export const Control = styled.div`
//   display: flex;
//   position: relative;
//   order: ${(props) => {
//     switch (props.control) {
//       case 'zoom':
//         return '1;';
//       case 'size':
//         return '2;';
//       default:
//         return 0;
//     }
//   }};
//   padding: 2px 5px;
//   overflow: hidden;
// `;

// Control.BtnClose = styled.button`
//   position: absolute;
//   top: -2px;
//   left: -2px;
//   background: none;
//   border: 0;

//   color: #de3b3b;
//   z-index: 2;
// `;

// /* animacao para o load do componente */
// Control.Animated = styled.div`
//   display: flex;
//   flex-flow: row nowrap;

//   height: 2.5rem;

//   border: none;
//   background: none;

//   animation: ${slideInFromLeft} 0.5s ease-out 0s 1;
// `;

// /** Zoom */
// Control.ZoomBtnAct = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-left: 1px;
//   border: 1px solid #cbd0d8;
//   border-radius: 5px;
//   height: 40px;
//   width: 40px;
//   background: #fff;
//   color: #cbd0d8;

//   :hover {
//     background: ${darken(0.1, '#f2f5fc')};
//     color: ${darken(0.1, '#1789dd')};
//   }
// `;

// /** Size */
// Control.SizeInput = styled.div`
//   display: flex;

//   div {
//     padding: 1px;
//   }
// `;

// /**
//  * =====================================================================
//  * LEGENDA DE ATALHOS
//  * ---------------------------------------------------------------------
//  * Painel flutuante sobre o desenho, FECHADO por padrão. É aberto pelo
//  * botão "?" da barra de ferramentas ou pelas teclas "?" / F1, e fechado
//  * pelo mesmo caminho ou por Esc.
//  *
//  * Fica em position:absolute dentro do EditorWrapper de propósito: assim
//  * não empurra o layout nem reduz a área de trabalho quando está oculto.
//  * =====================================================================
//  */
// export const Atalhos = styled.aside`
//   position: absolute;
//   top: 8px;
//   right: 8px;
//   z-index: 99;

//   display: flex;
//   flex-direction: column;

//   width: 330px;
//   max-width: calc(100% - 16px);
//   max-height: calc(100% - 16px);

//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 12px;
//   box-shadow: 0 12px 30px rgba(23, 38, 59, 0.18);

//   overflow: hidden;
// `;

// Atalhos.Header = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 8px;

//   padding: 8px 10px;
//   border-bottom: 1px solid #eef2f7;
//   background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);

//   > strong {
//     font-size: 12px;
//     color: #2c405a;
//     text-transform: uppercase;
//     letter-spacing: 0.04em;
//   }
// `;

// Atalhos.BtnClose = styled.button`
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;

//   width: 22px;
//   height: 22px;

//   border: 0;
//   border-radius: 6px;
//   background: none;
//   color: #94a3b8;
//   cursor: pointer;

//   &:hover {
//     color: #de3b3b;
//     background: rgba(222, 59, 59, 0.08);
//   }
// `;

// /** corpo rolável: em tela baixa a legenda rola dentro dela mesma */
// Atalhos.Body = styled.div`
//   flex: 1 1 auto;
//   min-height: 0;
//   overflow-y: auto;
//   padding: 4px 10px 10px;
// `;

// Atalhos.Grupo = styled.div`
//   padding-top: 8px;

//   > span {
//     display: block;
//     margin-bottom: 4px;
//     font-size: 10px;
//     font-weight: 700;
//     color: #94a3b8;
//     text-transform: uppercase;
//     letter-spacing: 0.06em;
//   }
// `;

// Atalhos.Linha = styled.div`
//   display: flex;
//   align-items: baseline;
//   justify-content: space-between;
//   gap: 10px;

//   padding: 3px 0;
//   border-bottom: 1px dashed #f1f5f9;

//   &:last-child {
//     border-bottom: 0;
//   }

//   > p {
//     flex: 1 1 auto;
//     font-size: 11.5px;
//     line-height: 1.35;
//     color: #475569;
//   }

//   > div {
//     flex: 0 0 auto;
//     display: flex;
//     align-items: center;
//     gap: 3px;
//     white-space: nowrap;
//   }
// `;

// Atalhos.Tecla = styled.kbd`
//   display: inline-block;
//   min-width: 18px;
//   padding: 1px 5px;

//   font-family: inherit;
//   font-size: 10.5px;
//   font-weight: 700;
//   color: #2c405a;
//   text-align: center;

//   background: #f8fafc;
//   border: 1px solid #d8e0eb;
//   border-bottom-width: 2px;
//   border-radius: 5px;
// `;

import styled, { css, keyframes } from 'styled-components';
import { lighten, darken } from 'polished';
import { ReactSVG } from 'react-svg';

const slideInFromLeft = keyframes`
 from {
   transform: translateX(-100%);
 }

 to {
   transform: translateX(0);
 }
 `;

/**
 * O recuo lateral de 20px foi retirado: a área de trabalho do desenho
 * ganha essa largura de volta e o cartão da página já tem recuo próprio.
 * O min-height:0 é o que permite o Wrapper esticar até o fim da altura
 * disponível quando a página define uma altura de viewport.
 */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  border: 1px dashed #ccc;
  padding: 2px;
  width: 100%;

  /** ocupa toda a altura restante abaixo da barra de ferramentas */
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
`;

// export const ToolBar = styled.div`
//   padding: 5px 0;
//   display: flex;
//   align-items: center;

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: none;
//     border: 1px solid #ccc;
//     border-radius: 5px;
//     margin-right: 5px;
//     width: 30px;
//     height: 30px;
//   }
// `;

/**
 * =====================================================================
 * BARRA DE FERRAMENTAS EM UMA ÚNICA LINHA
 * ---------------------------------------------------------------------
 * Com flex-wrap a barra quebrava em duas ou três linhas em tela menor e
 * comia a altura do desenho — justamente onde o espaço é mais escasso.
 * Agora ela nunca quebra: rola na horizontal.
 *
 * Para o usuário não perder botão de vista, três recursos somados:
 *   1. barra de rolagem fina, sempre visível quando há transbordo;
 *   2. degradê nas pontas indicando que há mais conteúdo do lado;
 *   3. setas de rolagem, que aparecem só quando há para onde rolar.
 *
 * O botão de ajuda (?) fica FORA da área de rolagem, fixo à direita: é o
 * atalho para a legenda e precisa estar sempre alcançável.
 * =====================================================================
 */
export const ToolBarArea = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;

  margin-bottom: 6px;
  padding: 6px 8px;

  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);

  /**
   * Degradês nas pontas: dica visual de que a barra continua para o lado.
   * Ficam no container (e não na área que rola) para não acompanharem o
   * conteúdo durante a rolagem. pointer-events: none para não roubar o
   * clique dos botões que ficam por baixo.
   */
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 4px;
    bottom: 4px;
    width: 26px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.18s ease;
    z-index: 1;
  }

  &::before {
    left: 30px;
    background: linear-gradient(90deg, #fdfdfe 0%, rgba(253, 253, 254, 0) 100%);
    ${(props) =>
      props.temEsq &&
      css`
        opacity: 1;
      `}
  }

  &::after {
    right: 60px;
    background: linear-gradient(
      270deg,
      #fbfcfe 0%,
      rgba(251, 252, 254, 0) 100%
    );
    ${(props) =>
      props.temDir &&
      css`
        opacity: 1;
      `}
  }
`;

/** seta de rolagem; só é renderizada quando existe transbordo daquele lado */
ToolBarArea.Nav = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 22px;
  height: 30px;
  padding: 0;

  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 8px;
  background: #fff;
  color: #5b6b82;
  cursor: pointer;

  &:hover {
    color: #ff6d3c;
    border-color: rgba(255, 109, 60, 0.45);
  }
`;

/** separador antes do botão de ajuda, que fica fixo fora da rolagem */
ToolBarArea.Fixo = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 8px;
  margin-left: 2px;
  border-left: 1px solid rgba(216, 224, 235, 0.9);

  /** mesmo visual dos botões da barra (que ficam na área de rolagem) */
  > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;
    background: #fff;
    color: #5b6b82;
    cursor: pointer;
    transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease;

    > svg {
      display: block;
    }

    &:hover {
      color: #ff6d3c;
      background: rgba(255, 109, 60, 0.1);
      border-color: rgba(255, 109, 60, 0.45);
    }

    &[aria-pressed='true'] {
      color: #ff6d3c;
      border-color: rgba(255, 109, 60, 0.45);
    }
  }
`;

export const ToolBar = styled.div`
  flex: 1 1 auto;
  min-width: 0;

  display: flex;
  align-items: center;
  /** nunca quebra a linha: o excedente vira rolagem horizontal */
  flex-wrap: nowrap;
  gap: 6px;

  overflow-x: auto;
  overflow-y: hidden;

  /**
   * Sem "scroll-behavior: smooth" aqui de propósito. Como propriedade
   * CSS ela também anima a rolagem da roda do mouse: cada evento soma
   * sobre uma posição que ainda está em movimento, e o gesto fica
   * arrastado e impreciso. As setas usam scrollBy({behavior:'smooth'}),
   * que suaviza só o clique nelas.
   */

  /** espaço para a barra de rolagem não cobrir os botões */
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(23, 38, 59, 0.18);
    border-radius: 3px;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgba(23, 38, 59, 0.32);
  }

  /** firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(23, 38, 59, 0.25) transparent;

  > button {
    /** não encolhe: em barra que rola, botão apertado fica ilegível */
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;
    background: #fff;
    color: #5b6b82;
    cursor: pointer;
    transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease,
      box-shadow 0.18s ease, transform 0.18s ease;

    > svg {
      display: block;
    }

    &:hover:not(:disabled) {
      color: #ff6d3c;
      background: rgba(255, 109, 60, 0.1);
      border-color: rgba(255, 109, 60, 0.45);
      box-shadow: 0 6px 14px rgba(255, 109, 60, 0.18);
      transform: translateY(-1px);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
      box-shadow: 0 3px 8px rgba(255, 109, 60, 0.22);
    }

    &:focus-visible {
      outline: none;
      border-color: rgba(255, 109, 60, 0.6);
      box-shadow: 0 0 0 3px rgba(255, 109, 60, 0.18);
    }

    &:disabled {
      color: #c2cad6;
      background: #f1f5f9;
      border-color: rgba(216, 224, 235, 0.7);
      cursor: not-allowed;
      box-shadow: none;
      transform: none;
    }

    /* botão primário (Salvar / submit) em destaque */
    &[type='submit'] {
      color: #fff;
      background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
      border-color: transparent;
      box-shadow: 0 6px 14px rgba(34, 197, 94, 0.28);

      &:hover:not(:disabled) {
        color: #fff;
        background: linear-gradient(135deg, #1fb555 0%, #28c763 100%);
        border-color: transparent;
        box-shadow: 0 10px 20px rgba(34, 197, 94, 0.4);
        transform: translateY(-1px);
      }
    }
  }
`;

// export const ToolBar = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 16px;
//   padding: 3px 4px;
//   flex-wrap: wrap;
//   background: #fff;
//   border-bottom: 1px solid #e6e6e6;
// `;

export const ToolGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 4px 8px;
  border-radius: 8px;
  background: #f8f8f8;
`;

export const Divider = styled.div`
  width: 1px;
  height: 18px;
  background: #e0e0e0;
  margin: 0 4px;
`;

export const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 0;
  background: transparent;
  &:hover {
    background: #eee;
  }
  &[aria-pressed='true'] {
    background: #ddd;
    box-shadow: inset 0 0 0 1px #bbb;
  }
`;

export const Segmented = styled.div`
  display: inline-flex;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
`;

export const SegBtn = styled(Btn)`
  width: 34px;
  height: 28px;
  border-radius: 0;
  &:not(:last-child) {
    border-right: 1px solid #ddd;
  }
`;

export const DPad = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 14px);
  grid-template-rows: repeat(3, 14px);
  gap: 2px;
  align-items: center;
  justify-items: center;
  & > button {
    width: 14px;
    height: 14px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    &:hover {
      background: #eee;
    }
  }
  & > button:nth-child(1) {
    grid-column: 1;
    grid-row: 2;
  } /* esquerda */
  & > button:nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  } /* cima */
  & > button:nth-child(3) {
    grid-column: 2;
    grid-row: 3;
  } /* baixo */
  & > button:nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  } /* direita */
`;

export const SVG = styled(ReactSVG)`
  /**
   * =====================================================================
   * O DESENHO OCUPA TODA A ÁREA DE TRABALHO
   * ---------------------------------------------------------------------
   * O react-svg monta wrapper (este componente) > div interna > svg. Os
   * três precisam preencher a área, senão o <svg> fica no tamanho dos
   * atributos width/height (614x874) e sobra espaço vazio em volta.
   *
   * Com width/height em 100% e o viewBox definido em handleResize, o
   * preserveAspectRatio padrão (xMidYMid meet) escala o desenho para
   * caber e o centraliza sozinho — sem conta de posicionamento.
   * =====================================================================
   */
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  /** div interna criada pelo react-svg */
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  /**
   * O react-svg repassa as props extras para o wrapper (um <div>), e é
   * nele que ficam o tabIndex="0" e os handlers de teclado. Sem nenhuma
   * indicação visual o usuário não tinha como saber se o desenho estava
   * com o foco — e portanto por que Del / Alt+Z / Alt+S não respondiam.
   */
  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px rgba(255, 109, 60, 0.35);
  }

  svg {
    /** fluido: o tamanho vem da área, não dos atributos do arquivo */
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    display: block;

    tspan,
    text {
      pointer-events: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: -moz-none;
      -o-user-select: none;
      user-select: none;
    }

    a:hover {
      > circle,
      rect {
        &.inject:hover {
          fill: ${lighten(0.1, '#538061')};
        }
      }

      > text {
        stroke: #f5f5f5;
        fill: #f5f5f5;
      }
    }

    a.highlight {
      > circle,
      rect {
        &.inject {
          fill: ${lighten(0.1, '#538061')};
        }
      }

      > text {
        stroke: #f5f5f5;
        fill: #f5f5f5;
      }
    }

    &.selected {
      stroke: red;
      fill: red;
    }

    circle,
    rect {
      &.inject {
        stroke: green;
      }

      &.warning {
        stroke: red;
      }
    }

    #linkGroup {
      a {
        &.selected {
          circle,
          rect {
            stroke: blue;
          }
        }

        &.focused {
          circle,
          rect {
            stroke-width: 1.8px;
          }
        }
      }
    }

    #ocrGroup {
      a {
        rect {
          fill: rgba(255, 255, 255, 0.1);
          stroke: none;
        }

        :hover {
          rect.success {
            stroke: green;
          }

          rect.warning {
            stroke: red;
          }
        }

        &.selected {
          > rect.success {
            stroke: green;
          }

          > rect.warning {
            stroke: red;
          }
        }

        > text.success {
          fill: green;
          stroke: green;
        }

        > text.warning {
          fill: red;
          stroke: red;
        }
      }
    }
  }
`;

export const EditorWrapper = styled.div`
  position: relative;
  border: 1px solid #ccc;

  /**
   * Preenche o Wrapper para o react-zoom-pan-pinch receber uma altura
   * real. Com altura automática o centerOnInit não tinha referência e a
   * área útil ficava limitada ao tamanho intrínseco do SVG.
   */
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
`;

export const ControlWrapper = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  z-index: 97;
`;

export const Control = styled.div`
  display: flex;
  position: relative;
  order: ${(props) => {
    switch (props.control) {
      case 'zoom':
        return '1;';
      case 'size':
        return '2;';
      default:
        return 0;
    }
  }};
  padding: 2px 5px;
  overflow: hidden;
`;

Control.BtnClose = styled.button`
  position: absolute;
  top: -2px;
  left: -2px;
  background: none;
  border: 0;

  color: #de3b3b;
  z-index: 2;
`;

/* animacao para o load do componente */
Control.Animated = styled.div`
  display: flex;
  flex-flow: row nowrap;

  height: 2.5rem;

  border: none;
  background: none;

  animation: ${slideInFromLeft} 0.5s ease-out 0s 1;
`;

/** Zoom */
Control.ZoomBtnAct = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1px;
  border: 1px solid #cbd0d8;
  border-radius: 5px;
  height: 40px;
  width: 40px;
  background: #fff;
  color: #cbd0d8;

  :hover {
    background: ${darken(0.1, '#f2f5fc')};
    color: ${darken(0.1, '#1789dd')};
  }
`;

/** Size */
Control.SizeInput = styled.div`
  display: flex;

  div {
    padding: 1px;
  }
`;

/**
 * =====================================================================
 * LEGENDA DE ATALHOS
 * ---------------------------------------------------------------------
 * Painel flutuante sobre o desenho, FECHADO por padrão. É aberto pelo
 * botão "?" da barra de ferramentas ou pelas teclas "?" / F1, e fechado
 * pelo mesmo caminho ou por Esc.
 *
 * Fica em position:absolute dentro do EditorWrapper de propósito: assim
 * não empurra o layout nem reduz a área de trabalho quando está oculto.
 * =====================================================================
 */
export const Atalhos = styled.aside`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 99;

  display: flex;
  flex-direction: column;

  width: 330px;
  max-width: calc(100% - 16px);
  max-height: calc(100% - 16px);

  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(23, 38, 59, 0.18);

  overflow: hidden;
`;

Atalhos.Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  padding: 8px 10px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);

  > strong {
    font-size: 12px;
    color: #2c405a;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
`;

Atalhos.BtnClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 22px;
  height: 22px;

  border: 0;
  border-radius: 6px;
  background: none;
  color: #94a3b8;
  cursor: pointer;

  &:hover {
    color: #de3b3b;
    background: rgba(222, 59, 59, 0.08);
  }
`;

/** corpo rolável: em tela baixa a legenda rola dentro dela mesma */
Atalhos.Body = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 4px 10px 10px;
`;

Atalhos.Grupo = styled.div`
  padding-top: 8px;

  > span {
    display: block;
    margin-bottom: 4px;
    font-size: 10px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`;

Atalhos.Linha = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;

  padding: 3px 0;
  border-bottom: 1px dashed #f1f5f9;

  &:last-child {
    border-bottom: 0;
  }

  > p {
    flex: 1 1 auto;
    font-size: 11.5px;
    line-height: 1.35;
    color: #475569;
  }

  > div {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 3px;
    white-space: nowrap;
  }
`;

Atalhos.Tecla = styled.kbd`
  display: inline-block;
  min-width: 18px;
  padding: 1px 5px;

  font-family: inherit;
  font-size: 10.5px;
  font-weight: 700;
  color: #2c405a;
  text-align: center;

  background: #f8fafc;
  border: 1px solid #d8e0eb;
  border-bottom-width: 2px;
  border-radius: 5px;
`;
